// Подключаем практически весь старый фронт:
// - angular 1.5.x и связанные пакеты
// - все созданные для angular модули, компонты и подобное
// - необходимые библиотеки: jQuery 2.2, Bootstrap 3, Moment.js, videojs, d3, sk3, ...
//
// Lyrics:
// > This is my legacy
// > Life or death to me
// > It's like the air I breathe
// > And you can't suffocate me now
import '@legacy';

import '@/assets/icons';
import '@/assets/fonts/golos/font.css';
import '@/assets/styles/main.scss';
import { createVueBridge, type VueBridge } from '@/services/ng-app-bridge/vue-app';
import { registerVueComponent, registerVueComponentBridgeDirective } from '@/services/ng-app-bridge/vue-component.directive';
import { setupLegacyOptionsGlobal, loadControlOptions, setLegacyOptions } from '@/services/legacy-options';
import * as globalComponents from '@/components/global';

declare global {
  interface Window {
    vueBridge: VueBridge;
  }
}

// Run, baby, run!
bootstrapApp();

async function bootstrapApp() {
  setupLegacyOptionsGlobal();

  const vueBridge = createVueBridge();
  window.vueBridge = vueBridge; // export global

  registerGlobalComponents(vueBridge);
  registerVueComponentBridgeDirective(window.angular, vueBridge, 'vueComponent');

  try {
    const serverOptions = await loadControlOptions();
    setLegacyOptions(serverOptions);
    console.log('Application configured! ->', serverOptions);
  } catch {
    console.error('Не удалось получить настойки с сервера');
  }

  document.querySelector('.--l12-app-not-loaed').classList.remove('--l12-app-not-loaed');
  window.angular.bootstrap(document, ['app']);
}

function registerGlobalComponents(vueBridge: VueBridge) {
  for (const [name, component] of Object.entries(globalComponents)) {
    vueBridge.app.component(name, component);
    registerVueComponent(name, component);
  }
}
